/*
 * Basket: the required "When should your first box arrive?" chooser: a row of date cards (the next delivery days,
 * closed days greyed with the reason, assets/bb-dates.css) with the full month calendar behind "All dates".
 * Same date rules as the builder (assets/bb-builder.js): delivery weekdays,
 * days' notice and booking window come from Theme settings → Butcher Ben.
 * Picking a date rewrites the box line's properties with /cart/change.js,
 * keeping its selling plan, and adds:
 *   'Delivery day', 'First delivery' (shown to the customer and on the order)
 *   _bb_first_delivery (ISO date, read by the charge-date automation)
 * Checkout stays disabled until a date is chosen; a saved date that has since
 * become too soon (the basket was left for a few days) counts as not chosen.
 */
function reloadInPlace() {
  try { sessionStorage.setItem('bb_cart_y', String(window.scrollY)); } catch (e) {}
  location.reload();
}

// Free meat safety net: the basket marks a box that lost its free meat line (sections/bb-cart.liquid);
// put the line back and refresh. Checkout stays locked until it's there.
(function () {
  var m = document.querySelector('[data-bb-addgift]');
  if (!m) return;
  // One automatic try per tab, so a refusal can never loop the page
  var tried = null;
  try { tried = sessionStorage.getItem('bb_addgift_tried'); sessionStorage.setItem('bb_addgift_tried', '1'); } catch (e) {}
  if (tried) { m.textContent = 'We couldn’t add your free meat. Please go back to your box and choose it again.'; return; }
  fetch('/cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
    body: JSON.stringify({items: [{id: +m.getAttribute('data-bb-addgift'), quantity: 1, properties: {_bb_role: 'free_gift', _bb_box_sku: m.getAttribute('data-sku')}}]})})
    .then(function (r) { if (!r.ok) throw new Error(); location.reload(); })
    .catch(function () { m.textContent = 'We couldn’t add your free meat. Please go back to your box and choose it again.'; });
})();

// Extras and Christmas − / +: change the line in the background, then swap in just the extras card, the Christmas
// card and the summary (Shopify's section rendering), so nothing reloads and the page stays exactly where it is on a
// phone. The date card is left alone. Falls back to an in-place reload if the section can't be fetched, or when the
// last Christmas item goes (the basket's layout changes).
function refreshCartParts(withBox) {
  var wrap = document.querySelector('.bb-cart') && document.querySelector('.bb-cart').closest('.shopify-section');
  var id = wrap && wrap.id.replace(/^shopify-section-/, '');
  if (!id) return Promise.reject();
  return fetch('/cart?section_id=' + encodeURIComponent(id))
    .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (!doc.querySelector('.bb-cart__summary')) throw new Error();
      var y = window.scrollY;
      // The extras card (it disappears when the last extra goes)
      // After a first-delivery date is saved the box line has a new key and new properties: its card (the
      // "Remove box" form, the Delivery day lines) comes fresh too. The date card itself is kept.
      if (withBox) {
        var dOld = document.querySelector('[data-bb-date]'), dNew = doc.querySelector('[data-bb-date]');
        var bOld = dOld && dOld.previousElementSibling, bNew = dNew && dNew.previousElementSibling;
        if (bOld && bNew && bOld.matches('.bb-cart__card') && bNew.matches('.bb-cart__card')) bOld.replaceWith(bNew);
      }
      // The Christmas card lists its lines the same way, so it's kept out of the extras match (4 Nov 2026)
      var EXTRAS = '.bb-cart__card:not(.bbx-basket) .bb-cart__extras';
      var oldX = document.querySelector(EXTRAS), newX = doc.querySelector(EXTRAS);
      var oldCard = oldX && oldX.closest('.bb-cart__card'), newCard = newX && newX.closest('.bb-cart__card');
      var oldXmas = document.getElementById('bb-christmas-delivery'), newXmas = doc.getElementById('bb-christmas-delivery');
      if (oldXmas && !newXmas) throw new Error('last Christmas item gone');
      if (oldXmas) oldXmas.replaceWith(newXmas);
      if (oldCard && newCard) oldCard.replaceWith(newCard); else if (oldCard) oldCard.remove();
      // The summary, keeping whatever is typed in the delivery note
      var note = document.querySelector('[data-bb-note]'), typed = note && note.value;
      document.querySelector('.bb-cart__summary').replaceWith(doc.querySelector('.bb-cart__summary'));
      var note2 = document.querySelector('[data-bb-note]');
      if (note2 && typed != null) note2.value = typed;
      document.dispatchEvent(new CustomEvent('bb:cart-updated'));
      window.scrollTo(0, y);
    });
}
(function () {
  // Put the reader back where they were after an in-place reload (the browser doesn't always).
  try {
    var y = sessionStorage.getItem('bb_cart_y');
    if (y !== null) { sessionStorage.removeItem('bb_cart_y'); window.scrollTo(0, +y); }
  } catch (e) {}
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.bb-cart__qty a, .bbx-basket__qty a');
    if (!a || a.hasAttribute('data-busy')) return;
    var q = new URL(a.href, location.href).searchParams;
    e.preventDefault();
    a.setAttribute('data-busy', '');
    // By the line's key, not its position: a position goes stale when the basket changes in another tab (3 Nov 2026)
    var body = q.get('id') ? {id: q.get('id'), quantity: +q.get('quantity')} : {line: +q.get('line'), quantity: +q.get('quantity')};
    fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)})
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function (cart) {
        // The header's basket count, which the partial refresh doesn't redraw
        Array.prototype.forEach.call(document.querySelectorAll('[data-bb-cart-count]'), function (c) { c.textContent = cart.item_count; });
        return refreshCartParts().catch(reloadInPlace);
      })
      // The line is gone or changed (another tab, an expired basket): show the basket as it is now, never Shopify's error page
      .catch(function () { reloadInPlace(); })
      .then(function () { a.removeAttribute('data-busy'); });
  });
})();

(function () {
  var box = document.querySelector('[data-bb-date]');
  var cfgEl = document.getElementById('bb-cart-dates');
  if (!box || !cfgEl) return;
  var C = JSON.parse(cfgEl.textContent);
  var DAYS = String(C.days || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  // UK clock (GMT/BST, whatever the visitor's own device says): every "today", cut-off and countdown runs on UK time,
  // so the clocks changing, or a customer abroad, never moves a deadline. Returns a Date whose fields are the UK wall clock.
  function ukClock() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', {timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'})
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = +x.value; });
      return new Date(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    } catch (e) { return new Date(); }
  }
  var today = (function () { var t = ukClock(); return new Date(t.getFullYear(), t.getMonth(), t.getDate()); })();
  var addDays = function (d, n) { return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); };
  var iso = function (d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); };
  var parseIso = function (s) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || ''); if (!m) return null; var d = new Date(+m[1], +m[2] - 1, +m[3]); return iso(d) === s ? d : null; };
  var weekday = function (d) { return DAY_NAMES[d.getDay()]; };
  var BLACKOUT = String(C.blackout || '').split(/[\s,]+/).filter(Boolean); // closed dates (bank holidays)
  var deliverable = function (d) { var t = d.getTime(); return t >= addDays(today, C.leadDays).getTime() && t <= addDays(today, C.bookingDays).getTime() && DAYS.indexOf(weekday(d)) >= 0 && BLACKOUT.indexOf(iso(d)) < 0; };
  var ordinal = function (n) { var v = n % 100; if (v >= 11 && v <= 13) return n + 'th'; return n + ({1: 'st', 2: 'nd', 3: 'rd'}[n % 10] || 'th'); };
  var fmtLong = function (d, year) { return d.toLocaleDateString('en-GB', {weekday: 'long'}) + ' ' + ordinal(d.getDate()) + ' ' + d.toLocaleDateString('en-GB', {month: 'long'}) + (year ? ' ' + d.getFullYear() : ''); };
  var fmtShort = function (d) { return d.toLocaleDateString('en-GB', {weekday: 'short'}) + ' ' + ordinal(d.getDate()) + ' ' + d.toLocaleDateString('en-GB', {month: 'short'}); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]; }); };

  // Line properties as a plain {name: value} object. Accepts [[name, value], …] or
  // {"0": [name, value], …} too, so a line saved in that shape gets repaired on the next save.
  function asObject(raw) {
    var out = {};
    var add = function (v, k) { if (Array.isArray(v) && v.length === 2 && typeof v[0] === 'string') out[v[0]] = v[1]; else if (k != null && !/^\d+$/.test(k)) out[k] = v; };
    if (Array.isArray(raw)) raw.forEach(function (v) { add(v); });
    else if (raw && typeof raw === 'object') Object.keys(raw).forEach(function (k) { add(raw[k], k); });
    return out;
  }
  var props = {};
  try { props = asObject(JSON.parse(box.getAttribute('data-props'))); } catch (e) {}
  var weeks = +((/(\d+)\s*week/i.exec(props.Frequency || '') || [])[1] || 0);
  var picked = parseIso(box.getAttribute('data-picked'));
  var expired = picked && !deliverable(picked);
  if (expired) picked = null;
  var busy = false, error = '';
  var first = new Date(today.getFullYear(), today.getMonth(), 1);
  var lastD = addDays(today, C.bookingDays), last = new Date(lastD.getFullYear(), lastD.getMonth(), 1);
  var soonest = addDays(today, C.leadDays);
  var month = picked ? new Date(picked.getFullYear(), picked.getMonth(), 1) : new Date(soonest.getFullYear(), soonest.getMonth(), 1);

  function lock(on) {
    var btn = document.querySelector('[data-bb-checkout]'), warn = document.querySelector('[data-bb-date-warn]');
    if (!btn) return;
    btn.disabled = on;
    btn.type = on ? 'button' : 'submit';
    if (on) btn.removeAttribute('name'); else btn.setAttribute('name', 'checkout');
    if (warn) warn.hidden = !on;
    box.classList.toggle('is-needed', on);
  }

  // The next delivery days for the cards: every delivery weekday from the soonest date, the closed ones (bank
  // holidays) kept in the row, greyed with the reason, so a missing Tuesday never looks like a mistake.
  var CARDS = 10;
  function cardDates() {
    var out = [], end = addDays(today, C.bookingDays);
    for (var d = soonest; out.filter(function (x) { return x.ok; }).length < CARDS && d <= end; d = addDays(d, 1)) {
      if (DAYS.indexOf(weekday(d)) < 0) continue;
      out.push({d: d, ok: deliverable(d), why: BLACKOUT.indexOf(iso(d)) >= 0 ? 'Closed' : ''});
    }
    return out;
  }
  var moreOpen = false;
  // The cards first; the month calendar opens under "All dates" (open from the start when the chosen date is
  // further out than the cards). Then the delivery plan for the chosen date.
  function render() {
    var lead = (month.getDay() + 6) % 7, daysIn = new Date(month.getFullYear(), month.getMonth() + 1, 0).getDate(), cells = [];
    for (var i = 0; i < lead; i++) cells.push(null);
    for (var d = 1; d <= daysIn; d++) cells.push(new Date(month.getFullYear(), month.getMonth(), d));
    while (cells.length % 7) cells.push(null);
    var weekStart = addDays(today, -((today.getDay() + 6) % 7));
    var list = cardDates();
    if (picked && !list.some(function (x) { return iso(x.d) === iso(picked); })) moreOpen = true;
    var firstOk = list.find(function (x) { return x.ok; });
    var cards = '<div class="bb-dates" data-bb-dates><ul class="bb-dates__row" aria-label="Delivery days">' + list.map(function (x) {
      var on = picked && iso(x.d) === iso(picked);
      var inner = '<span class="bb-datecard__wd">' + esc(x.d.toLocaleDateString('en-GB', {weekday: 'short'})) + '</span><span class="bb-datecard__d">' + x.d.getDate() + '</span><span class="bb-datecard__m">' + esc(x.d.toLocaleDateString('en-GB', {month: 'short'})) + '</span>' +
        (x.why ? '<span class="bb-datecard__tag">' + x.why + '</span>' : x === firstOk ? '<span class="bb-datecard__tag">Soonest</span>' : '');
      return '<li>' + (x.ok
        ? '<button type="button" class="bb-datecard"' + ' data-date="' + iso(x.d) + '"' + (busy ? ' aria-disabled="true"' : '') + ' aria-pressed="' + !!on + '"' + (on && busy ? ' aria-busy="true"' : '') + ' aria-label="' + esc(fmtLong(x.d)) + '">' + inner + '</button>'
        : '<span class="bb-datecard is-off" aria-label="' + esc(fmtLong(x.d)) + ', ' + (x.why ? 'closed' : 'not available') + '">' + inner + '</span>') + '</li>';
    }).join('') + '</ul><div class="bb-dates__foot">' +
      '<button type="button" class="bb-dates__more" data-more aria-expanded="' + moreOpen + '">' + (moreOpen ? 'Hide calendar' : 'All dates') + '</button></div></div>';
    var cal = '';
    if (moreOpen) {
      cal = '<div class="bbb-cal"><div class="bbb-cal__nav"><button type="button" data-month="-1" aria-label="Previous month"' + (month > first ? '' : ' disabled') + '>‹</button><div aria-live="polite">' + month.toLocaleDateString('en-GB', {month: 'long', year: 'numeric'}) + '</div><button type="button" data-month="1" aria-label="Next month"' + (month < last ? '' : ' disabled') + '>›</button></div>' +
        '<div class="bbb-cal__grid" role="grid" aria-label="First delivery date"><div class="bbb-cal__row" role="row">' + ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map(function (w) { return '<div role="columnheader" class="bbb-cal__wd">' + w + '</div>'; }).join('') + '</div>';
      for (var r = 0; r < cells.length / 7; r++) {
        var week = cells.slice(r * 7, r * 7 + 7);
        var lastDay = week.filter(Boolean).pop();
        if (lastDay && lastDay < weekStart) continue;
        cal += '<div class="bbb-cal__row" role="row">';
        week.forEach(function (c) {
          if (!c) { cal += '<div role="gridcell" aria-hidden="true"></div>'; return; }
          var ok = deliverable(c), on = picked && iso(c) === iso(picked), isToday = iso(c) === iso(today);
          cal += '<div role="gridcell" aria-selected="' + !!on + '"><button type="button" class="bbb-cal__day' + (on ? ' is-on' : ok ? ' is-ok' : '') + (isToday ? ' is-today' : '') + '"' + (ok ? ' data-date="' + iso(c) + '"' : '') + ' aria-disabled="' + !(ok && !busy) + '" aria-label="' + (isToday ? 'Today, ' : '') + fmtLong(c) + (ok ? '' : ', not available') + '"><span>' + c.getDate() + '</span>' + (isToday ? '<em>Today</em>' : '') + '</button></div>';
        });
        cal += '</div>';
      }
      cal += '</div><p class="bb-cart__key"><span class="bb-cart__key-ok"></span>We can deliver <span class="bb-cart__key-on"></span>Your date</p></div>';
    }
    var plan = '';
    if (picked) {
      var dates = [picked];
      for (var k = 1; k < 4 && weeks; k++) dates.push(addDays(picked, weeks * 7 * k));
      plan = '<div class="bb-cart__plan"><p class="bb-cart__plan-k">' + (busy ? 'Saving your date…' : 'Your first box') + '</p>' +
        '<p class="bb-cart__plan-date">' + esc(fmtLong(picked)) + '</p>' +
        (weeks ? '<p class="bb-cart__plan-sub">Then every ' + weeks + ' weeks on a ' + weekday(picked) + '.</p><ol class="bb-cart__plan-list">' + dates.slice(1).map(function (x, j) {
          return '<li><span>Box ' + (j + 2) + '</span><span>' + esc(fmtShort(x)) + '</span></li>';
        }).join('') + '</ol><p class="bb-cart__plan-note">Change or skip any box from your account until ' + (C.closeDays || 3) + ' days before it’s delivered.</p>' : '') + '</div>';
    }
    var html = (expired ? '<p class="bb-cart__warn">The date you chose earlier is now too soon for us to pack your box. Please choose a new one.</p>' : '') +
      '<div class="bb-cart__datewrap' + (moreOpen ? ' is-open' : '') + '">' + cards + cal + plan + '</div>';
    if (error) html += '<p class="bb-cart__warn" role="alert">' + esc(error) + '</p>';
    var keep = box.querySelector('.bb-dates__row'), x0 = keep ? keep.scrollLeft : null;
    box.querySelector('[data-bb-cal]').innerHTML = html;
    var row = box.querySelector('.bb-dates__row'), wrapEl = box.querySelector('[data-bb-dates]');
    if (row && wrapEl) {
      var on = row.querySelector('[aria-pressed="true"]');
      // keep the row where it was on a redraw; on load, bring the chosen card to the middle (never under an edge fade)
      if (x0 != null) row.scrollLeft = x0; else if (on) row.scrollLeft = Math.max(0, on.parentNode.offsetLeft - (row.clientWidth - on.parentNode.offsetWidth) / 2);
      var edges = function () { var max = row.scrollWidth - row.clientWidth; wrapEl.toggleAttribute('data-more-left', row.scrollLeft > 4); wrapEl.toggleAttribute('data-more-right', max - row.scrollLeft > 4); };
      row.addEventListener('scroll', edges, {passive: true});
      edges();
    }
  }

  function save(dateIso) {
    var d = parseIso(dateIso);
    if (!d || busy) return;
    busy = true; error = ''; picked = d; expired = false; render();
    // No checkout mid-save (a changed date isn't on the basket yet); no warning either, a date is chosen
    var co = document.querySelector('[data-bb-checkout]'); if (co) co.disabled = true;
    var next = {};
    Object.keys(props).forEach(function (k) { next[k] = props[k]; });
    next['Delivery day'] = weekday(d);
    next['First delivery'] = fmtLong(d, true);
    next._bb_first_delivery = dateIso;
    var body = {id: box.getAttribute('data-key'), quantity: 1, properties: next};
    var plan = box.getAttribute('data-plan');
    if (plan) body.selling_plan = +plan;
    fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)})
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'We couldn’t save that date. Please try again.'); return j; }); })
      // Reload after saving (as before 3 Nov 14:47). The no-reload version went live at 14:47 and the next box ordered
      // (#BB21076) renewed with Recharge's default contents instead of its cuts: Recharge's own cart script seems to
      // need the reload to keep the box linked to its picks (_rb_id) once the line's key changes. The days still keep
      // their normal look while saving (no greying).
      .then(function () { reloadInPlace(); })
      .catch(function (e) { busy = false; error = e.message; picked = null; lock(true); render(); });
  }

  box.addEventListener('click', function (e) {
    if (e.target.closest('[data-more]')) { moreOpen = !moreOpen; render(); return; }
    var m = e.target.closest('[data-month]');
    if (m && !m.disabled) { month = new Date(month.getFullYear(), month.getMonth() + (+m.getAttribute('data-month')), 1); render(); return; }
    var day = e.target.closest('[data-date]');
    if (day) save(day.getAttribute('data-date'));
  });

  lock(!picked);
  render();
  document.addEventListener('bb:cart-updated', function () { lock(!picked); });
})();

// Delivery instructions: saved to the cart note as the customer types (picking a date reloads the basket, so an
// unsaved note would be lost). The checkout form also posts it as `note`.
(function () {
  var t = null;
  document.addEventListener('input', function (e) {
    var f = e.target.closest && e.target.closest('[data-bb-note]');
    if (!f) return;
    clearTimeout(t);
    t = setTimeout(function () {
      fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({note: f.value.trim().slice(0, 200)})}).catch(function () {});
    }, 600);
  });
})();

// Phones: a slim bar with the total and Checkout, shown while the summary's own button is off screen. It presses
// that button (so the date lock and every other rule still apply), or scrolls to the note saying what's missing.
(function () {
  var bar = document.querySelector('[data-bb-bar]');
  if (!bar || !('IntersectionObserver' in window)) return;
  var phone = window.matchMedia('(max-width: 749px)');
  var real = function () { return document.querySelector('.bb-cart__summary .bb-cart__checkout'); };
  var seen = false;
  var sync = function () {
    var b = real();
    bar.hidden = !phone.matches || !b || seen;
    var btn = bar.querySelector('[data-bb-bar-btn]'), total = document.querySelector('.bb-cart__summary .bb-cart__total dd');
    if (b && btn) btn.textContent = b.disabled ? 'Continue' : 'Checkout';
    if (total) bar.querySelector('strong').textContent = total.textContent.trim(); // the summary is swapped after extras change
  };
  var io = new IntersectionObserver(function (es) { seen = es.some(function (e) { return e.isIntersecting; }); sync(); });
  var watch = function () { io.disconnect(); var b = real(); if (b) io.observe(b); sync(); };
  bar.addEventListener('click', function (e) {
    if (!e.target.closest('[data-bb-bar-btn]')) return;
    var b = real(); if (!b) return;
    if (!b.disabled) { b.click(); return; }
    var need = document.querySelector('.bb-cart__date.is-needed, #bb-christmas-delivery .is-needed, .bb-cart__card--stray, .bb-cart__summary .bb-cart__warn:not([hidden])');
    (need || b).scrollIntoView({behavior: 'smooth', block: 'center'});
  });
  if (phone.addEventListener) phone.addEventListener('change', sync);
  document.addEventListener('bb:cart-updated', watch);
  watch();
})();
